import React from 'react';
import './CeoSection.css'
import { Primary,Secondary,Tertiary } from '../Constants/Colours';
import AboutUsImage from '../Images/AboutPageImages/SamImage.jpeg'


function AboutSection() {
  return (
    <div style={{backgroundColor:'#79b0cc'}} className="CEO-Section">
        <div style={{backgroundColor:'#79b0cc'}}>
            <img src={AboutUsImage}/>
            <div style={{backgroundColor:'#79b0cc'}}>
                
                <div>
                <h1>About Me</h1>
                <h3><span>Hello my name is Sam</span>, I am a  fully qualified, Gas Safe registered domestic Gas Engineer with over 21 years of hands-on experience, including 14 years proudly serving as an engineer with British Gas.
<br/><br/>
During my time at British Gas, I built a strong foundation in installing, servicing, and repairing gas appliances and central heating systems. That experience shaped my commitment to high standards, safety, and top-tier customer service, values I continue to bring to every job today.

I take pride in delivering quality workmanship with a sharp eye for detail, whether I’m diagnosing a fault, fitting a new boiler, or carrying out a routine safety check. I know how important it is to feel confident in the work being done in your home, so I always aim to be punctual, professional, and clear in my communication.
<br/><br/>
By staying up to date with the latest regulations and technology, I make sure you receive modern, safe, and efficient solutions tailored to your home.
<br/><br/>
When you work with me, you're getting more than just a Gas engineer, you’re getting a trusted professional with years of experience at the very heart of the industry</h3>
                </div>
            </div>
        </div>
    </div>
  );
}

export default AboutSection;